module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "navbar navbar-default",
    style: (_vm.backgroundColor)
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    style: (_vm.fontColor),
    attrs: {
      "to": {
        name: 'dashboard'
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.appName) + "\n                ")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "bs-example-navbar-collapse-1"
    }
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [(_vm.user) ? _c('li', {
    staticClass: "user-action dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    style: (_vm.fontColor),
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "user-avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.user.profile_photo_large ? _vm.user.profile_photo_large : '/static/images/blank-profile-picture.png',
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v("\n                            Hello, " + _vm._s(_vm.user.first_name) + "\n                        ")])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": _vm.profileLink,
      "target": "_blank"
    }
  }, [_vm._v("Profile")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout($event)
      }
    }
  }, [_vm._v("Logout")])])])]) : _c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      },
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v("\n                            Login\n                        ")])])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "navbar-form-custom navbar-form navbar-left hide"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('i', {
    staticClass: "icon fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8d290a90","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/commons/Header.vue
// module id = 447
// module chunks = 57